module.exports = __webpack_public_path__ + "img/Photo-E-Giannothanasis.aeab1ab0.jpg";